import React from "react";
import { CouponType } from "types";
import { BxgyCouponEditor } from "./BxgyCouponEditor";
import { CouponEditorProps } from "./CouponEditorProps";
import { DiscountCouponEditor } from "./DiscountCouponEditor";
import { UnlockCouponEditor } from "./UnlockCouponEditor";
import { VoucherCouponEditor } from "./VoucherCouponEditor";

export const CouponDescriptionForm = (props: CouponEditorProps) => {
    const Editor = props.coupon?.type ? typeMap[props.coupon.type] : DiscountCouponEditor;
    return <Editor {...props} />;
};

const typeMap: Record<CouponType, (props: CouponEditorProps) => JSX.Element | null> = {
    [CouponType.DISCOUNT]: DiscountCouponEditor,
    [CouponType.VOUCHER]: VoucherCouponEditor,
    [CouponType.UNLOCK]: UnlockCouponEditor,
    [CouponType.BXGY]: BxgyCouponEditor,
    [CouponType.PERSON]: () => null,
};
